import { headerStyles } from "@insite/content-library/Widgets/MyLists/MyListsHeader";
import { css } from "styled-components";

headerStyles.leftBottomGridItem = {
    width: [12, 6, 6, 3, 4],
    css: css`
        @media (min-width: 992px) and (max-width: 1280px) {
            flex-basis: 36%;
            max-width: 36%;
        }
    `,
};
headerStyles.rightBottomGridItem = {
    width: [12, 6, 6, 4, 4],
    css: css`
        @media (min-width: 992px) and (max-width: 1280px) {
            flex-basis: 36%;
            max-width: 36%;
        }
    `,
};

headerStyles.leftTopGridItem = {
    width: [9, 10, 6, 6, 6],
    css: css``,
};

headerStyles.rightTopGridItem = {
    width: [3, 2, 6, 6, 6],
    css: css``,
};
